<!-- my-component.vue -->
<template>
<!-- Button trigger modal -->

<div class="landin-1-api">
    <div class="row" style="position:absolute;z-index:6;width:100vw;margin-left:0px;">
        <div class="hidden-xs col-md-2"></div>
        <div class="col-12 col-md-8 text-landing-1">
            <h1 class="title-landing">You're a developper and you're looking for a new coding adventure ?</h1>
            <h1 class="subtitle-landing">Send us a motivation mesage though our messaging service.</h1>
            <img  :src="hire" style="width:100px;padding-top:60px;" >
        </div>
        <div class="co-12 col-md-2" style="text-align:center;margin:0;">
           
        </div>
    </div>
</div>
</template>

<script scoped>

export default {
data() {
  return {
    msg: "Hello World!",
    isShowMyModal: false,
    hire: require('./assets/img/discover/hire.svg'),
    mobile_app: require('./assets/img/app/mobile-app.svg')
  }
}
  }
</script>
<style scoped>
/* mobile screen */
@media only screen and (max-width:70em) { 
.hidden-xs{
  display:none;
}
.landin-1-api{
  height:920px;
  position:relative;
/* gradient: */
background-image: linear-gradient(44deg, #57CA85 0%, #194F68 100%);
  padding-top:100px;
  width:100%;
}
}

/* big screen */
@media only screen and (min-width:70em) { 
.hidden-md{
  display:none;
}
.text-landing-1{
    padding-top:100px;
    text-align:center;
}
.landin-1-api{
  height:780px;
  position:relative;
/* gradient: */
background-image: linear-gradient(44deg, #57CA85 0%, #194F68 100%);
  padding-top:100px;
  width:100%;
}
}


.title-landing{
    font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:white;
font-size:34px;
font-weight:normal;
}

.subtitle-landing{
     font-family: Avenir Next, sans-serif;
-webkit-font-smoothing: antialiased;
color:rgb(199, 198, 198);
font-size:26px;
font-weight:normal; 
}

.landin-2-website{
  height:750px;
 background-color:white;
  width:100%;
  padding-top:800px;
}


</style>


// WEBPACK FOOTER //
// src/jobs.vue